export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторити операцію"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Історія операцій"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Список рахунків"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Невідома помилка"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Список токенів"])}
}